import { Vue, Component, Watch, Prop, Provide } from 'vue-property-decorator';
import SiteInfo from './siteInfo.vue';
import SiteConfig from './siteConfig';

@Component({
  components: {
    SiteInfo,
    SiteConfig,
  },
})
export default class SiteDisplay extends Vue {
  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Provide()
    mode = 0;

  @Provide()
  get isMoreSite() {
    return Number(+this.$route.params.isMoreSite);
  }

  // 网点Id
  @Provide()
    siteId = 0;

  created() {
    this.mode = +this.$route.params.mode;
    this.siteId = +this.$route.params.siteId;
  }

  render(h) {
    return this.mode === 2 ? <SiteConfig siteId={this.siteId} /> : <SiteInfo />;
  }
}
